"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const DistroToolHeader_vue_1 = __importDefault(require("./components/DistroToolHeader.vue"));
const DistroToolMain_vue_1 = __importDefault(require("./components/DistroToolMain.vue"));
const DistroService_1 = __importDefault(require("./controllers/services/DistroService"));
const SliderItemsController_1 = __importDefault(require("./controllers/controllers/SliderItemsController"));
let DistroToolView = class DistroToolView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.projectId = '';
        this.areaId = '';
        this.DISTRO_SERVICE = null;
        this.currentProjectId = 0;
        this.currentAreaId = 0;
        this.distribution = 'crop';
        this.currentSliderItemCropActive = '';
        this.count = 0;
    }
    async created() {
        var _a, _b;
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        this.projectId = params.get('projectId');
        this.areaId = params.get('areaId');
        this.currentProjectId = parseInt(params.get('projectId'));
        this.DISTRO_SERVICE = new DistroService_1.default(`/data/results/distro/tool?project_id=${this.projectId}&gis_area_id=${this.areaId}`);
        const propiedadesArray = [];
        for (const key in this.distroData.proposal.projects) {
            propiedadesArray.push(this.distroData.proposal.projects[key]);
        }
        this.currentSliderItemCropActive = (_b = (_a = new SliderItemsController_1.default(propiedadesArray, this.currentProjectId).currentItem) === null || _a === void 0 ? void 0 : _a.crop) === null || _b === void 0 ? void 0 : _b.name;
        await this.callDataDistro();
    }
    mounted() {
        this.callDataDistro();
    }
    reload() {
        if (this.currentSliderItemCropActive && this.count > 1) {
            this.DISTRO_SERVICE.fetchDistroDataCurrentCrop(`/data/results/distro/tool?project_id=${this.currentProjectId}&gis_area_id=${this.currentAreaId}`);
        }
        this.count += 1;
    }
    async callDataDistro() {
        await this.DISTRO_SERVICE.call();
    }
    newCurrentId(currentProjectId, currentAreaId) {
        this.currentProjectId = currentProjectId;
        this.currentAreaId = currentAreaId;
    }
    currentDistribution(distribution) {
        this.distribution = distribution;
    }
    get distroData() {
        return this.DISTRO_SERVICE.data;
    }
    get currentSliderItemId() {
        return this.currentProjectId;
    }
    get sliderItems() {
        var _a, _b;
        const propiedadesArray = [];
        for (const key in this.distroData.proposal.projects) {
            propiedadesArray.push(this.distroData.proposal.projects[key]);
        }
        this.currentSliderItemCropActive = (_b = (_a = new SliderItemsController_1.default(propiedadesArray, this.currentProjectId).currentItem) === null || _a === void 0 ? void 0 : _a.crop) === null || _b === void 0 ? void 0 : _b.name;
        return new SliderItemsController_1.default(propiedadesArray, this.currentProjectId);
    }
    get isDataLoading() {
        return this.DISTRO_SERVICE.isLoading;
    }
};
__decorate([
    (0, vue_property_decorator_1.Watch)('currentSliderItemCropActive')
], DistroToolView.prototype, "reload", null);
DistroToolView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            DistroToolHeader: DistroToolHeader_vue_1.default,
            DistroToolMain: DistroToolMain_vue_1.default,
        },
    })
], DistroToolView);
exports.default = DistroToolView;
